import { render, staticRenderFns } from "./KonzessionsThemaMobileCard.vue?vue&type=template&id=3876ad65&scoped=true&"
import script from "./KonzessionsThemaMobileCard.vue?vue&type=script&lang=js&"
export * from "./KonzessionsThemaMobileCard.vue?vue&type=script&lang=js&"
import style0 from "./KonzessionsThemaMobileCard.vue?vue&type=style&index=0&id=3876ad65&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3876ad65",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VTimeline } from 'vuetify/lib/components/VTimeline';
import { VTimelineItem } from 'vuetify/lib/components/VTimeline';
installComponents(component, {VBtn,VChip,VCol,VIcon,VProgressLinear,VRow,VSheet,VTimeline,VTimelineItem})
